



















































































interface Data{
  username : string
  password: string
  showLogInError: boolean
}

import Vue from "vue";
import Api from "@/api/api";
export default Vue.extend({
  name: "Login",
  data() : Data {
    return {
      username: "",
      password: "",
      showLogInError: false 
    };
  },

  methods: {
    async redirectReset() {
      this.$router.push("/reset");
    },
    async onSubmit() {
      this.$q.loading.show();
      try {
        const logInResult = await Api.logInAsync(this.username, this.password);
        if (logInResult) {
          this.$router.push("/");
        } else {
          this.$q.notify({
            progress: true,
            message: "Username e/o password non corretti.",
            type: "negative"
          });
        }
      } catch {
        this.$q.notify({
          progress: true,
          message: "Si è verificato un errore, riprovare più tardi.",
          type: "negative"
        });
      }

      this.$q.loading.hide();
    }
  }
});
